import { Loader2 } from "lucide-react";

export default function AppSpinner() {
  return (
    <div className="grid place-items-center min-h-[40vh]">
      <Loader2 className="w-6 h-6 animate-spin allow-spin" aria-label="Laster…" />
    </div>
  );
}
